/* eslint-disable no-sequences */
/* eslint-disable eqeqeq */
import reqwest from "reqwest";
import md5 from "./md5";
const defaultImg = require("../images/default_img.jpg");

const commonTools = {
  cnzzData: {
    property: 1,//1：男频 2：女频
  },
  r() {
    return /micromessenger/i.test(navigator.userAgent) ? navigator.userAgent.match(/micromessenger\/([\d\\.]+)/i)[1] : ""
  },
  a(e, t) {
      e = e.split(".");
    t = t.split(".");
    for (var n = e.length, o = t.length, r = 0; r < Math.max(n, o); r++) {
        var a = 0;
        r < n && (a = parseInt(e[r]));
        var i = 0;
        if (r < o && (i = parseInt(t[r])),
        a != i)
            return a > i ? 1 : -1
    }
    return 0
  },
  o() {
    return /(iphone|ipad|ipad|ios)/i.test(navigator.userAgent)
  },
  checkWX(){
    return this.o() && this.a(this.r(), "6.6.7") >= 0;
  },
  isWeiXin(){//判断是否是微信浏览器的函数
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      return true;
    }else{
      return false;
    }
  },
  numTo2(num){
    let t = parseInt(num) || 0;
    if(t<10){
      t = "0" + t;
    }
    return t;
  },
  addCnzz() {
    // 加载cnzz
    if (!!this.cnzzData.cnzz && !document.getElementById("cnzz_stat_icon_" + this.cnzzData.cnzz)) {
      let span = document.createElement("span");
      span.id = "cnzz_stat_icon_" + this.cnzzData.cnzz;
      document.body.appendChild(span);
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//w.cnzz.com/c.php?id=" + this.cnzzData.cnzz;
      document.body.appendChild(script);
    }
  },
  jsonToStr(data){
    let tempArr = [];
    for(let item in data){
      tempArr.push(`${item}=${((data[item])||"")}`);
    }
    return tempArr.join("&");
  },
  ksort: function(inputArr, sort_flags) {
    var tmp_arr = {},
      keys = [],
      sorter,
      i,
      k,
      that = this,
      strictForIn = false,
      populateArr = {};

    switch (sort_flags) {
      case "SORT_STRING":
        sorter = function(a, b) {
          return that.strnatcmp(a, b);
        };
        break;
      case "SORT_LOCALE_STRING":
        var loc = this.i18n_loc_get_default();
        sorter = this.php_js.i18nLocales[loc].sorting;
        break;
      case "SORT_NUMERIC":
        sorter = function(a, b) {
          return a + 0 - (b + 0);
        };
        break;
      default:
        sorter = function(a, b) {
          var aFloat = parseFloat(a),
            bFloat = parseFloat(b),
            aNumeric = aFloat + "" == a,
            bNumeric = bFloat + "" == b;
          if (aNumeric && bNumeric) {
            return aFloat > bFloat ? 1 : aFloat < bFloat ? -1 : 0;
          } else if (aNumeric && !bNumeric) {
            return 1;
          } else if (!aNumeric && bNumeric) {
            return -1;
          }
          return a > b ? 1 : a < b ? -1 : 0;
        };
        break;
    }

    for (k in inputArr) {
      if (inputArr.hasOwnProperty(k)) {
        keys.push(k);
      }
    }
    keys.sort(sorter);

    this.php_js = this.php_js || {};
    this.php_js.ini = this.php_js.ini || {};
    strictForIn =
      this.php_js.ini["phpjs.strictForIn"] &&
      this.php_js.ini["phpjs.strictForIn"].local_value &&
      this.php_js.ini["phpjs.strictForIn"].local_value !== "off";
    populateArr = strictForIn ? inputArr : populateArr;

    for (i = 0; i < keys.length; i++) {
      k = keys[i];
      tmp_arr[k] = inputArr[k];
      if (strictForIn) {
        delete inputArr[k];
      }
    }
    for (i in tmp_arr) {
      if (tmp_arr.hasOwnProperty(i)) {
        populateArr[i] = tmp_arr[i];
      }
    }

    return strictForIn || populateArr;
  },
  randomNum: function(num) {
    var numStr = "";
    var tempNum = num || 4;
    while (tempNum > 0) {
      numStr = numStr + "" + parseInt(Math.random() * 10);
      tempNum--;
    }
    return numStr;
  },
  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  },
  formatTime(date) {  
    var year = date.getFullYear()  
    var month = date.getMonth() + 1  
    var day = date.getDate()  
    
    var hour = date.getHours()  
    var minute = date.getMinutes()  
    var second = date.getSeconds()  
    
    return [year, month, day].map(this.formatNumber).join('-') + ' ' + [hour, minute, second].map(this.formatNumber).join(':')
  },
  checkLog(e,tempThis){
    if (!e.requestPar.url){
      return false;
    }
    reqwest({
      url: '//log.kxxsc.com/yd/exceptionlog/logswitch',
      method: 'get',
      crossOrigin: true, // 开启CORS跨域
      withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
      data: {
        'app_key': tempThis.app_key
      }, // 参数，弄成json字符串
      type: "json" // 参数类型JSON
    }).then(res=>{
      if (res.result.data.switch == '1'){
        this.postError(e,tempThis);
      }
    });
  },
  postError(e,tempThis){
    let pars = '';
    let tempArr = [];
    for (var item in e.requestPar.data) {
      let tempStr = item + '=' + ((e.requestPar.data[item])||"");
      tempArr.push(tempStr);
    }
    pars = tempArr.join('&');
    reqwest({
      url: '//log.kxxsc.com/yd/exceptionlog/report',
      method: 'post',
      crossOrigin: true, // 开启CORS跨域
      withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
      data: {
        app_key: tempThis.app_key,
        create_time: this.formatTime(new Date()),//接口返回错误时间(例如:2018 - 03 - 14 10:35:04)
        error_level: '1',//错误级别(1.error, 2.warn, 3.info, 4.debug, 5.trace)
        api_url: document.location.origin.substr(0,document.location.origin.indexOf("//"))+e.requestPar.url,//	string	是	请求接口地址
        project_name: tempThis.proName,//	string	是	项目名称
        user_id: tempThis.user_id,//用户id
        parameter: pars,//	string	否	请求接口传入的参数(a = XX & b=XX这种方式传递)
        receive_way: (e.requestPar.method||'get').toUpperCase()=='GET'?1:2,//接口请求方式(1.get, 2.post)
        api_result: e.responseText,//接口返回结果
        api_status: e.status,//接口状态(200, 502, 404......)
        operating_system: "操作系统",//操作系统(系统 + 版本号)
        phone_type: "手机型号",//	string	否	手机型号
      }, // 参数，弄成json字符串
      type: "json" ,// 参数类型JSON
      accept: "application/json, application/xml, text/plain, text/html, *.*",
      contentType: "application/x-www-form-urlencoded; charset=utf-8"
    });
  },
  cookieObj() {
    let cookieArr = document.cookie.split(";"),
      cookieObj = {};
    cookieArr.forEach(function(k) {
      let tempArr = k.split("=");
      cookieObj[((tempArr[0]) || "").trim()] = ((tempArr[1]) || "").trim();
    });
    return cookieObj;
  },
  searchPar(str) {
    if (!str) {
      str = document.location.href;
    }
    str = str.substr(str.lastIndexOf("?"));
    var par = {};
    var arr = ((((str) || "").substr(1)) || "").split("&");
    for (var i = 0; i < arr.length; i++) {
      var temp = ((arr[i]) || "").split("=");
      if (!!temp[0]) {
        par[temp[0]] = decodeURIComponent((temp[1]) || "");
      }
    }

    return par;
  },
  getData(tempOptions, tempThis) {
    tempOptions.data = tempOptions.data || {};
  
    tempOptions.data.req_time = new Date().getTime() + commonTools.randomNum();
    tempOptions.data.version = tempOptions.data.version || tempThis.version;
    tempOptions.data.app_secret = tempOptions.data.app_secret || tempThis.app_secret;
    tempOptions.data.user_token = tempOptions.data.user_token || tempThis.user_token;
    tempOptions.data.wechat_id = tempOptions.data.wechat_id || tempThis.wechat_id;
    if (!tempOptions.noEncrypt) {
      tempOptions.data.is_encrypt = tempOptions.data.is_encrypt || tempThis.is_encrypt;
    }

    if (!!tempOptions.isUser) {
      delete tempOptions.isUser;
    }
    if (!!tempOptions.isWechatId) {
      delete tempOptions.isWechatId;
    }
  
    let endData = tempOptions.data;
    let sortData = commonTools.ksort(tempOptions.data);
    let tempArr = [];
    for (var item in sortData) {
      if (item !== "__flush_cache" && item !== "access_token" && item !== "app_key") {
        let temVal = ((sortData[item]+"") || "");
        if(temVal == "undefined"){
          endData[item] = "";
          temVal = "";
        }
        let tempStr = item + "=" + temVal;
        tempArr.push(tempStr);
      }
    }
    if(!!tempOptions.clearArr&&tempOptions.clearArr.length>0){
    //   let tempArr = JSON.parse(localStorage.getItem("clearArr") || "[]");
        const tempArr = []
      localStorage.setItem("clearArr",JSON.stringify(new Set(Array.from(tempArr.concat(tempOptions.clearArr)))));
    }
    let sessionArr = JSON.parse(localStorage.getItem("clearArr") || "[]");
    if(sessionArr.length > 0){
      if(sessionArr.includes(tempOptions.url)){
        endData["__flush_cache"] = 1;
        // splice
        sessionArr.splice(sessionArr.indexOf(tempOptions.url),1);
        localStorage.setItem("clearArr",JSON.stringify(sessionArr));
      }
    }
    // console.log(tempArr.join("&"));
    if(!!tempOptions.app_token || !!tempThis.app_token){
      endData.app_token = md5.hexMD5(tempArr.join("&"));
    }else{
      endData.access_token = md5.hexMD5(tempArr.join("&"));
    }
    delete endData.app_secret;
    endData.app_key = tempOptions.app_key || tempThis.app_key;

    let url = (tempOptions.host || tempThis.host) + tempOptions.url;

    // console.log('endData: ', endData)
    let obj = {
      ...tempOptions,
      url: url, // URL
      method: tempOptions.method || "get", // 请求方式
      crossOrigin: true, // 开启CORS跨域
      withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
      data: endData, // 参数，弄成json字符串
      type: "json" // 参数类型JSON
    };
    if (obj.method.toLowerCase() == "post") {
      obj.accept =
        "application/json, application/xml, text/plain, text/html, *.*";
      obj.contentType = "application/x-www-form-urlencoded; charset=utf-8"; // 消息主体数据类型 JSON
      // obj.data = JSON.stringify(obj.data);
    }
    if (obj.callback) delete obj.callback
  
    return obj;
  },
  getAccredit(domainName, token){
    // 跳转授权
    try{
      // window.location.href = 'https://heisenyuedu.zizaotai.cn/mine?wechat_id=1554&user_token=bd03d62bb378a6e9d5064dbccc9aa75d&user_id=10711281'
      window.location.href = `${domainName}/zh/user/wxLoginv1?backurl=${encodeURIComponent(document.location.href)}${token ? '&current_token=' + token : ''}`;
    }catch(e){}
  },
  tongji(e) {
    if (window._czc) {
      let curT = e.currentTarget;
      let obj = {
        category:
          document.title + ":" + curT.getAttribute("data-category"),
        action:
          curT.getAttribute("data-action") +
          (curT.getAttribute("data-url") || ""),
        label: curT.getAttribute("data-label"),
        value: curT.getAttribute("data-value"),
        nodeid: curT.getAttribute("id")
      };
      /* 
      category	必填	string	表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等
      action	必填	string	表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等
      label	选填	string	用于更详细的描述事件，如具体是哪个视频，哪部小说
      value	选填	int	用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格
      nodeid	选填	string	填写事件元素的div元素id
       */
      window._czc.push([
        "_trackEvent",
        obj.category || "",
        obj.action || "",
        obj.label || "",
        obj.value || "",
        obj.nodeid || ""
      ]);
    }
  },
  errorImg(e){
    try{
      e.src = defaultImg;
      e.onerror = null;
    }catch(e){}
  },
};

export default commonTools;